import { trigger, state, style, transition, animate } from '@angular/animations';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { UserRoles } from 'src/app/enums/userRoles.enum';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { UserService } from 'src/app/services/user.service';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'app-sidebar3',
  templateUrl: './sidebar3.component.html',
  styleUrls: ['./sidebar3.component.css'],
  animations: [
    trigger('slideInOut', [
      state('void', style({
        transform: 'translateX(-100%)'
      })),
      state('*', style({
        transform: 'translateX(0%)'
      })),
      transition('void => *', [
        animate('0.5s ease-in-out', style({
          transform: 'translateX(0%)'
        }))
      ]),
      transition('* => void', [
        animate('0.5s ease-in-out', style({
          transform: 'translateX(-100%)'
        }))
      ])
    ])
  ]
})
export class Sidebar3Component {

  @Input() isOpen = false;

  @Input() activeOption: any;

  @Output() sideBarCollapseEmitter = new EventEmitter();

  isEmployeeExpanded: boolean = false;

  isExecutiveExpanded: boolean = false;

  isKmsExpanded: boolean = false;

  isPortalExpanded: boolean = false;

  isGovernanceExpanded: boolean = false;

  isOthersExpanded: boolean = false;

  childrensOfMegaMenu = {
    isEmployeeExpanded: [
      '/Home/Dashboard',
      'Home/Dashboard/Employee Impersonation',
      '/Home/employee-career/employee-Career-path',
      '/Home/employee-career/employee-Career-program',
      '/Home/employee-career/program-catalogue',
      'Home/employee-career/employee-Career-path/program-catalogue',
      '/Home/employee-career/add-programs',
      '/Home/employee-career/employee-Career-request/my-requests',
      '/Home/employee-career/employee-Career-request/team-requests',
    ],
    isKmsExpanded: [
      '/Home/KMSPortal',
      '/Home/KMS Portal',
      'Home/KMSPortal/Project Content',
      'Home/KMSPortal/Pending Approvals',
      '/users/userlist',
    ],
    isPortalExpanded: ['/Home/CMF Portal'],
    isGovernanceExpanded: ['/Home/Compliance', '/Home/Timesheet Management'],
    isOthersExpanded: [
      '/Home/Proposal Repository',
      '/Home/Artifactory Repository',
      '/Home/Artifactory',
      '/Home/ProjectTechStack',
      '/Home/Proof Of Concepts',
      '/Home/Audit',
      'Home/MasterQuestion',
    ],
  };

  public hideMenu = {
    dashboard: false,
    competency: false,
    home: false,
    employee: false,
    executive: false,
    techstack: false,
    salaryRangeCalcualtor: false,
    skillRepository: false,
    uploadData: false,
    employeData: false,
    templates: false,
    proposals: false,
    mockups: false,
    employeemenu: false,
    sales: false,
    salesdashboard: false,
    projectcontent: false,
    pendingapprovals: false,
    users: false,
    career: false,
    other: false,
    dmdPortal: false,
    ppmPortal: false,
    compliance: false,
    portal: false,
    audits: false,
    timeSheet: false,
    pstimesheet: false,
    poc:true,
    employeeWithoutCompetency: false,
  };

  showemployeeimpersonation: boolean = false;

  isEmpCareerManager: boolean = false;

  accessForAddPrograms: boolean = false;

  timesheetview: boolean = false;

  accessForKMS: boolean = false;

  allSections: string[] = [
    'isEmployeeExpanded',
    'isExecutiveExpanded',
    'isKmsExpanded',
    'isPortalExpanded',
    'isGovernanceExpanded',
    'isOthersExpanded',
    'isAuditsExpanded'
  ];

  empCareerUserDetailsSubcription: any;

  role: any;

  public loading = false;

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private auth: AuthServiceService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.role = this.auth.getRole();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.expandActiveParent();
    });
    this.callEmpCareerUserDetails();
    this.configureMenuBasedOnRoles();
  }

  isActiveProgramCatalogueLink() {
    const currentUrl = this.router.url;
    return currentUrl.startsWith('/Home/employee-career/employee-Career-path/program-catalogue') ||
      currentUrl.startsWith('/Home/employee-career/program-catalogue');
  }

  isActiveArtifactoryLink() {
    const currentUrl = this.router.url;
    return currentUrl.startsWith('/Home/Artifactory Repository') || currentUrl.startsWith('/Home/Artifactory');
  }

  isActiveKMSLink() {
    const currentUrl = this.router.url;
    return currentUrl.startsWith('/Home/KMSPortal') || currentUrl.startsWith('/Home/KMS%20Portal');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      this.expandActiveParent();
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    if (this.isOpen) {
      this.expandActiveParent();
      this.cdr.detectChanges();
    }
  }

  toggleSection(section: string): void {
    this.allSections.forEach((sec) => {
      if (sec === section) {
        this[sec] = !this[sec]; // Toggle the clicked section
      } else {
        this[sec] = false; // Collapse all other sections
      }
    });
  }

  callEmpCareerUserDetails() {
    this.empCareerUserDetailsSubcription = this.userService.empCareerUserDetails.subscribe(data => {
      let employeeDetails;
      if (data) {
        if (typeof data === 'string') {
          employeeDetails = JSON.parse(data);
        } else if (typeof data === 'object') {
          employeeDetails = data;
        }
        this.isEmpCareerManager = employeeDetails?.isManager;
        console.log();
        
        if(this.isEmpCareerManager)
        {
        this.showemployeeimpersonation=true;
        }
        if (employeeDetails.gradeId == 1 && employeeDetails.role == "Intern") {   
          this.hideMenu.poc = false;
        }
        if (
          this.role &&
          !this.role.includes(GsdRoles.PMORole) &&
          employeeDetails.gradeId != 1 &&
          employeeDetails.role != "Intern"
        ) {   
          this.hideMenu.timeSheet = true;
          this.timesheetview = true;
        }
      }
    })
  }

  expandActiveParent() {
    const currentUrl = this.router.url.split('%20').join(' ');
    const currentOption = Object.keys(this.childrensOfMegaMenu).find(key =>
      this.childrensOfMegaMenu[key].some(path => currentUrl.includes(path))
    );
    if (currentOption) {
      this.allSections.forEach((section) => {
        if (section === currentOption) {
          this[section] = true;
        } else {
          this[section] = false;
        }
      });
    } else {
      this.isEmployeeExpanded = true;
    }
  }

  configureMenuBasedOnRoles() {
    if (
      this.role.includes(UserRoles.Admin) ||
      this.role.includes(UserRoles.SuperAdmin) ||
      this.role.includes(UserRoles.ContentManager) ||
      this.role.includes(UserRoles.Viewer)
    ) {
      this.accessForKMS = true;
    }

    if (this.role.includes(GsdRoles.Admin)) {
      this.setAdminRolesAccess();
    }

    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.setSuperAdminRolesAccess();
    }
    
    if (this.role.includes(GsdRoles.SkillUser)) {
      this.setUserRolesAccess();
    }

    if (this.role.includes(GsdRoles.CompetencyLeader)) {
      this.setCompetencyLeaderRolesAccess();
    }

    if (this.role.includes(GsdRoles.SubCompetencyLeader)) {
      this.setSubCompetencyLeaderRolesAccess();
    }

    if (this.role.includes(GsdRoles.Leadership)) {
      this.setLeadershipRolesAccess();
    }

    if (this.role.includes(UserRoles.Viewer)) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = true;
      this.hideMenu.pendingapprovals = true;
      this.hideMenu.users = true;
    }
  
    if (this.role.includes(UserRoles.ContentManager)) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = false;
      this.hideMenu.pendingapprovals = true;
      this.hideMenu.users = true;
    }

    if (
      this.role.includes(UserRoles.Admin) ||
      this.role.includes(UserRoles.SuperAdmin)
    ) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = false;
      this.hideMenu.pendingapprovals = false;
      this.hideMenu.users = false;
    }
  }

  setLeadershipRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = false;
    this.hideMenu.templates = true;
    this.hideMenu.competency = false;
    this.hideMenu.portal = true;
    this.hideMenu.uploadData = false;
    this.hideMenu.employeData = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = true;
    this.hideMenu.proposals = true;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = false;
    this.hideMenu.other = true;
    this.hideMenu.ppmPortal = true;
    this.hideMenu.dmdPortal = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setSubCompetencyLeaderRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = false;
    this.hideMenu.portal = false;
    this.hideMenu.uploadData = false;
    this.hideMenu.employeData = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = false;
    this.hideMenu.proposals = false;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setCompetencyLeaderRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = false;
    this.hideMenu.portal = false;
    this.hideMenu.uploadData = false;
    this.hideMenu.employeData = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = false;
    this.hideMenu.proposals = false;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setUserRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.uploadData = false;
    this.hideMenu.skillRepository = false;
    this.hideMenu.employeeWithoutCompetency = false;
    this.hideMenu.templates = false;
    this.hideMenu.competency = false;
    this.hideMenu.portal = false;
    this.hideMenu.employeData = false;
    this.hideMenu.proposals = false;
    this.hideMenu.mockups = false;
    this.hideMenu.employeemenu = false;
    this.hideMenu.sales = false;
    this.hideMenu.home = true;
    this.hideMenu.career = true;
    this.hideMenu.employee = false;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = false;
    this.hideMenu.salaryRangeCalcualtor = false;
    this.hideMenu.other = false;
    this.hideMenu.compliance = false;
    this.hideMenu.poc = true;
  }

  setSuperAdminRolesAccess() {
    this.accessForAddPrograms = true;
    this.hideMenu.dashboard = true;
    this.hideMenu.uploadData = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.employeeWithoutCompetency = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = true;
    this.hideMenu.portal = true;
    this.hideMenu.ppmPortal = true;
    this.hideMenu.dmdPortal = true;
    this.hideMenu.employeData = true;
    this.hideMenu.proposals = true;
    this.hideMenu.mockups = true;
    this.hideMenu.employeemenu = true;
    this.hideMenu.sales = true;
    this.hideMenu.salesdashboard = false;
    this.hideMenu.projectcontent = false;
    this.hideMenu.pendingapprovals = false;
    this.hideMenu.users = false;
    this.hideMenu.career = true;
    this.hideMenu.executive = true;
    this.hideMenu.techstack = true;
    this.hideMenu.salaryRangeCalcualtor = true;
    this.hideMenu.other = true;
    this.hideMenu.compliance = true;
    this.hideMenu.audits = true;
    this.timesheetview = true;
    this.showemployeeimpersonation = true;
  }

  setAdminRolesAccess() {
    this.hideMenu.dashboard = true;
    this.hideMenu.uploadData = true;
    this.hideMenu.skillRepository = true;
    this.hideMenu.templates = true;
    this.hideMenu.competency = true;
    this.hideMenu.portal = true;
    this.hideMenu.ppmPortal = true;
    this.hideMenu.dmdPortal = true;
    this.hideMenu.employeData = true;
    this.hideMenu.proposals = true;
    this.hideMenu.mockups = true;
    this.hideMenu.employeemenu = true;
    this.hideMenu.sales = true;
    this.hideMenu.salesdashboard = false;
    this.hideMenu.projectcontent = false;
    this.hideMenu.pendingapprovals = false;
    this.hideMenu.users = false;
    this.hideMenu.career = true;
    this.hideMenu.executive = false;
    this.hideMenu.techstack = true;
    this.hideMenu.salaryRangeCalcualtor = false;
    this.hideMenu.other = true;
    this.showemployeeimpersonation = true;
  }

  navigateTo(path) {
    this.loading = true;
    this.router.navigate([path])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  isEmpCareerActivated(): boolean {
    const empCarrerUrls = [
      '/Home/employee-career/employee-Career-program',
      '/Home/employee-career/employee-Career-request',
      '/Home/employee-career/employee-Career-request/my-requests',
      '/Home/employee-career/employee-Career-request/team-requests',
      '/Home/employee-career/program-catalogue',
      '/Home/employee-career/add-programs'
    ]
    return empCarrerUrls.includes(this.router.url);
  }

  programCatalogueNavigate(): void {
    this.loading = true;
    this.isEmpCareerActivated() ? this.router.navigate(['Home/employee-career/employee-Career-path'])
      .then(() => {
        this.router.navigateByUrl(
          '/Home/employee-career/employee-Career-path/program-catalogue',
          { state: { selectedGrade: '' } }
        );
        this.loading = false
      })
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      }) : this.router.navigate(['Home/employee-career/'])
        .then(() => {
          this.router.navigateByUrl(
            '/Home/employee-career/program-catalogue', 
            { state: { selectedGrade: '' } }
          );
          this.loading = false
        })
        .catch(err => {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: '280px',
            data: { message: 'Cannot Open', class: 'text-danger' }
          });
        });
    this.dismissSidebar();
  }

  salaryRangeNavigate(): void {
    let salaryCalculatorUrl = 'http://172.16.0.45:8074?id_token=' + localStorage.getItem('MsSSOToken');
    window.open(salaryCalculatorUrl, "_blank");
    this.dismissSidebar();
  }

  dismissSidebar() {
    this.isOpen = false;
    const activeOption = this.allSections.find(section => this[section]);
    this.sideBarCollapseEmitter.emit({
      isSideBarOpen: this.isOpen,
    });
  }

  ngOnDestroy(): void {
    this.empCareerUserDetailsSubcription?.unsubscribe();
  }
}
